import { InformationCircleIcon, QuestionMarkCircleIcon } from '@heroicons/react/16/solid';
import React, { useState } from 'react';

const Tooltip = ({ text }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative inline-block z-10">
      <div
        className="cursor-pointer"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        onClick={() => setVisible(!visible)}
      >
        <QuestionMarkCircleIcon className="w-4 h-4 text-gray-300" />
      </div>
      {visible && (
        <div className="absolute bottom-full mb-2 w-56 -translate-x-1/2 p-2 bg-gray-700 text-white text-sm rounded-sm shadow-lg">
          {text}
        </div>
      )}
    </div>
  );
};

export default Tooltip;